import { Component, OnInit,Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';
import { SharedService } from 'src/app/utils/shared.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as CommonConstants from '../../utils/common.constants';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/masters/master.service';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';

@Component({
  selector: 'app-pomr-actd',
  templateUrl: './pomr-actd.component.html',
  styleUrls: ['./pomr-actd.component.scss']
})
export class POMRACTDComponent implements OnInit {
  patientHistory=[];
  patientHistoryRowData = [];
  familyHistoryRowData=[];
  familyAtcdRowData=[];
  familyHistory=[];
  familyAtcd=[];
  fAtcdList=[];
  masterValues=[];
  relationship=[];
  patientHistoryDefs;
  familyHistoryDefs;
  familyAtcdDefs;
  patientHistForm: FormGroup;
  familyHistForm: FormGroup;
  familyAtcdForm: FormGroup;
  frameworkComponents;
  treatment;
  status;
  pHistgridApi: GridApi;
  fHistgridApi: GridApi;
 fAtcdgridApi: GridApi;
  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }
  @Input() medFileId;
  PARAM_KEY=[CommonConstants.RELATIONSHIP,CommonConstants.TREATMENT_TYPE,CommonConstants.STATUS];
  SERVICE_KEYS=[CommonConstants.PATIENT_HISTORY,CommonConstants.FAMILY_HISTORY,CommonConstants.FAMILY_ATCD];
  fileStatus: string;
  constructor(private fb: FormBuilder,private modal: NgbModal,private medicalFileService:MedicalFileService,private masterService: MasterService
     ,private toastrService: ToastrService,private sharedService: SharedService) {
    //this.getFormGroup();
  //this.getFamilyHistFormGroup();
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
    this.fileStatus=localStorage.getItem(CommonConstants.FILE_STATUS);
   }

  ngOnInit() {
    this.loadMaster();
    if(this.sharedService.medicalFileId$){
      this.loadPomrAtcdDetails();
    }
  }
  loadMaster() {
     this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
       if (response && response['result']) {
         this.masterValues = response['result'];
         this.relationship=this.masterValues.filter(master => master.paramKey === CommonConstants.RELATIONSHIP);
         this.treatment=this.masterValues.filter(master => master.paramKey === CommonConstants.TREATMENT_TYPE);
         this.status=this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
       }
     });
   }
  patientHistoryAddModal(addPatientHistory) {
    //this.patientHistoryRowData = [];
    this.modal.open(addPatientHistory, { size: 'lg',container: '.page-content' });
    if (!this.patientHistoryDefs) {
      this.getPatientHistoryGrid();
    }

  }
  familyHistoryAddModal(addfamilyHistory) {
    this.modal.open(addfamilyHistory, { size: 'lg',container: '.page-content' });
    if (!this.familyHistoryDefs) {
      this.getFamilyHistoryGrid();
    }

  }
  familyAtcdAddModal(addfamilyATCD) {
    this.modal.open(addfamilyATCD, { size: 'xl', container: '.page-content' });
    if (!this.familyAtcdDefs) {
      this.getFamilyAtcdGrid();
    }

  }
  loadPomrAtcdDetails() {
    this.medicalFileService.getDetailsByKeys(this.medFileId, this.SERVICE_KEYS).subscribe(response => {
      if (response && response['code'] === 'S0000' && response['result']) {
        this.patientHistory = response['result'][CommonConstants.PATIENT_HISTORY];
        //this.patientHistoryRowData = this.patientHistory;
        this.familyHistory = response['result'][CommonConstants.FAMILY_HISTORY].map(item =>({
          ...item,
           relationvalue:item.relatId ? this.relationship.find(obj => obj.id === +item.relatId).value:null
        }));
        //this.familyHistoryRowData = this.familyHistory;
        this.fAtcdList = response['result'][CommonConstants.FAMILY_ATCD].map(item =>({
          ...item,
          relationvalue:item.relatId ? this.relationship.find(obj => obj.id === +item.relatId).value:null,
          treatmentvalue:item.treatCode ? this.treatment.find(obj => obj.id === +item.treatCode).value:null,
          statusvalue:item.statuCode ? this.status.find(obj => obj.id === +item.statuCode).value : null
        }));
       // this.familyAtcdRowData = this.fAtcdList;
      } else {
        swal.fire("Error", response['message'], 'error');
      }
    },
      error => {
        swal.fire("Error", "Error Occured While Fetching Medical File Details", 'error');
      })
  }

  getPatientHistoryGrid() {
    //add diagnotic 
    this.patientHistoryDefs = [
      { headerName: 'Code', field: 'medphVaCode' },
      { headerName: 'Date', field: 'medphDtDate', cellEditor: 'agDateInput' },
      { headerName: 'Description', field: 'medphVaDesc' },
      { headerName: 'Solved Date', field: 'medphDtSolved', cellEditor: 'agDateInput' }
    ];
  }

  getFamilyHistoryGrid() {
    //add diagnotic 
    this.familyHistoryDefs = [
      { headerName: 'Code', field: 'medfhVaCode' },
      { headerName: 'relatId', field: 'relatId' ,hide:true},
      {
        headerName: 'Relationship', field: 'relationvalue', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.relationship, dataColumn: 'relatId', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'Description', field: 'medfhVaDesc' },
      { headerName: 'Solved Date', field: 'medfhDtSolved', cellEditor: 'agDateInput' }
    ];
  }

  getFamilyAtcdGrid() {
    //add diagnotic 
    this.familyAtcdDefs = [
      { headerName: 'relatId', field: 'relatId' ,hide:true},
      {
        headerName: 'Relationship', field: 'relationvalue', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.relationship, dataColumn: 'relatId', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'Diagnostic', field: 'medfmVaDiagnostic' },
      { headerName: 'Description', field: 'medfmVaDesc' },
      { headerName: 'Discovery Date', field: 'medfmDtDiscovery', cellEditor: 'agDateInput' },
      { headerName: 'From', field: 'medfmDtFrom', cellEditor: 'agDateInput' },
      { headerName: 'To', field: 'medfmDtTo', cellEditor: 'agDateInput' },
      { headerName: 'treatCode', field: 'treatCode' ,hide:true},
      {
        headerName: 'Treatment', field: 'treatmentvalue', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.treatment, dataColumn: 'treatCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'statuCode', field: 'statuCode' ,hide:true},
      {
        headerName: 'Status', field: 'statusvalue', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      }
    ];
  }

  /* private getFormGroup() {
    this.patientHistForm = this.fb.group({
      'medphId': new FormControl(),
      'medfiId': new FormControl(),
      'medphDtDate': new FormControl(),
      'medphDtSolved': new FormControl(),
      'medphVaCode': new FormControl(),
      'medphVaDesc': new FormControl(),
      'staRecCode': new FormControl(),
    })
  }
  private getFamilyHistFormGroup() {
    this.familyHistForm= this.fb.group({
      'medfhId': new FormControl(),
      'medfiId': new FormControl(),
      'relatId': new FormControl(),
      'medfhDtSolved': new FormControl(),
      'medfhVaCode': new FormControl(),
      'medfhVaDesc': new FormControl(),
      'staRecCode': new FormControl(),
    })
  } */
  onGridReadyPatientHistory(params) {
    this.pHistgridApi = params.api;
    this.pHistgridApi.sizeColumnsToFit();
  }
  addNewPatientHistory() {
    const newRow = { medphVaCode: '', medphDtDate: '', medphVaDesc: '', medphDtSolved: '' };
    this.patientHistoryRowData.push(newRow);
    this.pHistgridApi.setRowData(this.patientHistoryRowData);
  }
  onpatientHistoryRowSelect(addPatientHistory) {
    if(this.fileStatus==='NEW'){
    this.getPatientHistoryGrid();
    this.modal.open(addPatientHistory, { size: 'lg', container: '.page-content' });
    this.patientHistoryRowData = this.patientHistory;
    }
  }

  get f() { return this.patientHistForm.controls; }


  onGridReadyFamilyHistory(params) {
    this.fHistgridApi = params.api;
    this.fHistgridApi.sizeColumnsToFit();
  }
  addNewFamilyHistory() {
    const newFHist = { medfhVaCode: '', relatId: '', medfhVaDesc: '', medfhDtSolved: '' };
    this.familyHistoryRowData.push(newFHist);
    this.fHistgridApi.setRowData(this.familyHistoryRowData);
  }
  onFamilyHistoryRowSelect(addFamilyHistory) {
    if(this.fileStatus==='NEW'){
    this.getFamilyHistoryGrid();
    this.modal.open(addFamilyHistory, { size: 'lg', container: '.page-content' });
    this.familyHistoryRowData = this.familyHistory;
    }
  }

  get family() { return this.familyHistForm.controls; }


  onGridReadyFamilyAtcd(params) {
    this.fAtcdgridApi = params.api;
    this.fAtcdgridApi.sizeColumnsToFit();
  }
  addNewFamilyAtcd() {
    const newAtcd = { relatId: '', medfmVaDiagnostic: '', medfmVaDesc: '', medfmDtDiscovery: '' , medfmDtFrom: '', medfmDtTo: '', treatCode: '', statuCode: ''};
    this.familyAtcdRowData.push(newAtcd);
    this.fAtcdgridApi.setRowData(this.familyAtcdRowData);
  }
  onFamilyAtcdRowSelect(addFamilyAtcd) {
    if(this.fileStatus==='NEW'){
    this.getFamilyAtcdGrid();
    this.modal.open(addFamilyAtcd, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.familyAtcdRowData = this.fAtcdList;
    }
  }

  get atcd() { return this.familyAtcdForm.controls; }

  savePatientHistory() {
    this.patientHistoryRowData = this.patientHistoryRowData.map(item => ({
      ...item,
      'medfiId': this.medFileId
    }));
    this.patientHistoryRowData=this.patientHistoryRowData.filter(item=> item.edited && item.edited===true);
    this.medicalFileService.savePatientHistory(this.patientHistoryRowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        //if (res["result"][0])
        for(let item of res["result"]){
          this.patientHistory.push(item);
        }
        this.patientHistory = Object.values(this.patientHistory.reduce((acc,c)=>(acc[c.medphId]=c,acc),{}));
        this.patientHistory = [...this.patientHistory];
        this.modal.dismissAll();
      }
    })
  }

  saveFamilyHistory() {
    this.familyHistoryRowData = this.familyHistoryRowData.map(item => ({
      ...item,
      'medfiId': this.medFileId
    }));
    this.familyHistoryRowData=this.familyHistoryRowData.filter(item=> item.edited && item.edited===true);
    this.medicalFileService.saveFamilyHistory(this.familyHistoryRowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        //if (res["result"][0])
        for(let item of res["result"]){
          this.familyHistory.push(item);
        }
        this.familyHistory = Object.values(this.familyHistory.reduce((acc,c)=>(acc[c.medfhId]=c,acc),{}));
        this.familyHistory = [...this.familyHistory];
        this.familyHistory = this.familyHistory .map(item =>({
          ...item,
           relationvalue:item.relatId ? this.relationship.find(obj => obj.id === +item.relatId).value:null
        }));
        this.modal.dismissAll();
      }
    })
  }
saveFamilyAtcd(){
  this.familyAtcdRowData = this.familyAtcdRowData.map(item => ({
    ...item,
    'medfiId': this.medFileId
  }));
  this.familyAtcdRowData=this.familyAtcdRowData.filter(item=> item.edited && item.edited===true);
  this.medicalFileService.saveFamilyAtcd(this.familyAtcdRowData).subscribe(res => {
    if (res && res["result"]) {
      this.toastrService.success("Saved Succesffully");
      for(let item of res["result"]){
        this.familyAtcd.push(item);
        this.fAtcdList.push(item);
      }
       this.familyAtcd = Object.values(this.familyAtcd.reduce((acc,c)=>(acc[c.medfmId]=c,acc),{}));
      this.familyAtcd = [...this.familyAtcd];
      this.fAtcdList = Object.values(this.fAtcdList.reduce((acc,c)=>(acc[c.medfmId]=c,acc),{}));
      this.fAtcdList = this.fAtcdList.map(item =>({
        ...item,
        relationvalue:item.relatId ? this.relationship.find(obj => obj.id === +item.relatId).value:null,
        treatmentvalue:item.treatCode ? this.treatment.find(obj => obj.id === +item.treatCode).value:null,
        statusvalue:item.statuCode ? this.status.find(obj => obj.id === +item.statuCode).value : null
      }));
      //this.fAtcdList = [...this.fAtcdList];
      this.modal.dismissAll();
    }
  })
}
onCellValueChanged(params: any) {
 if(!params.data.edited && params.newValue != params.oldValue){
  params.data["edited"]=true;
 }
}
}
